var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1429 2.57143H0.857143C0.383036 2.57143 0 2.95446 0 3.42857V20.5714C0 21.0455 0.383036 21.4286 0.857143 21.4286H23.1429C23.617 21.4286 24 21.0455 24 20.5714V3.42857C24 2.95446 23.617 2.57143 23.1429 2.57143ZM22.0714 5.53928V19.5H1.92857V5.53928L1.18929 4.96339L2.24196 3.61071L3.38839 4.50268H20.6143L21.7607 3.61071L22.8134 4.96339L22.0714 5.53928ZM20.6143 4.5L12 11.1964L3.38571 4.5L2.23929 3.60803L1.18661 4.96071L1.92589 5.53661L11.0759 12.6509C11.339 12.8553 11.6628 12.9663 11.996 12.9663C12.3292 12.9663 12.6529 12.8553 12.9161 12.6509L22.0714 5.53928L22.8107 4.96339L21.758 3.61071L20.6143 4.5Z",
    fill: "#2A2A2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email.570afbc5.svg";
export { ForwardRef as ReactComponent };